export const content = {
  title: "Geographic Insights",
  filterLabel: "Geographies",
  subtitle:
    "See how your channels are performing in different geographic regions, or review a specific geography for new opportunities.",
};

export const noDataContent = {
  title: "No Geography Data Available",
  description:
    "There is no geographic data available for the selected filters. Please adjust your selection and try again.",
};
